const App_Studio_Dark = {
    accent: "#FFB3B4",
    accent_positive: "#357E94",
    accent_negative: "#F4564E",
    background_content: "#202020",
    background_page: "#202020",
    body_text: "#FFFFFF",
    border: "#606060",
    border_style: {
        name: "underlined",
        borderWidth: "0px 0px 1px 0px",
        borderStyle: "solid",
        borderRadius: 0,
    },
    button_border: {
        width: "1px",
        color: "#595959",
        radius: "0px",
    },
    button_capitalization: "uppercase",
    button_background_color: "#FFB3B4",
    button_text: "#101010",
    control_border: {
        width: "1px",
        color: "#464646",
        radius: "0px",
    },
    control_background_color: "#202020",
    control_text: "#FFFFFF",
    card_margin: "16px",
    card_padding: "8px",
    card_border: {
        width: "1px 1px 1px 1px",
        style: "solid",
        color: "#606060",
        radius: "0px",
    },
    card_background_color: "#202020",
    card_box_shadow: "0px 0px 0px rgba(0,0,0,0)",
    card_outline: {
        width: "0px",
        style: "solid",
        color: "white",
    },
    card_header_margin: "0px",
    card_header_padding: "10px",
    card_header_border: {
        width: "0px",
        style: "solid",
        color: "#DDD",
        radius: "0px",
    },
    card_accent: "#606060",
    card_header_accent: "#606060",
    card_header_background_color: "#202020",
    card_header_box_shadow: "0px 0px 0px rgba(0,0,0,0)",
    card_description_background_color: "#202020",
    card_description_text: "#FFFFFF",
    card_description_font_size: "16px",
    card_title_text: "#FFFFFF",
    card_title_font_size: "20px",
    card_menu_background_color: "#DDDDDD",
    card_menu_text: "#FFFFFF",
    breakpoint_font: "1200px",
    breakpoint_stack_blocks: "700px",
    color_scheme: "dark",
    colorway: [
        "#FFB3B4",
        "#80CFBE",
        "#60BAB6",
        "#F4564E",
        "#FFEEB2",
        "#FFFFFF",
        "#FADDD2",
        "#FFDD68",
        "#357E94",
        "#A1ACC3",
    ],
    colorscale: [
        "#5E0D24",
        "#7E132F",
        "#9E1A3A",
        "#BE2045",
        "#DE2750",
        "#F0315B",
        "#F5496C",
        "#F9617D",
        "#FA7990",
        "#FBA1A3",
    ],
    dbc_primary: "#FFB3B4",
    dbc_secondary: "#A6A6A6",
    dbc_info: "#00769F",
    dbc_gray: "#ADB5BD",
    dbc_success: "#00CCA4",
    dbc_warning: "#FADD6A",
    dbc_danger: "#F76065",
    font_family: "Inter",
    font_family_header: "Inter",
    font_family_headings: "Inter",
    font_size: "16px",
    font_size_smaller_screen: "12px",
    font_size_header: "24px",
    title_capitalization: "capitalize",
    header_content_alignment: "spread",
    header_margin: "0px 0px 16px 0px",
    header_padding: "0px",
    header_border: {
        width: "0px 0px 0px 0px",
        style: "solid",
        color: "white",
        radius: "0px",
    },
    header_background_color: "#DDDDDD",
    header_controls_background_color: "#202020",
    header_box_shadow: "none",
    header_text: "#FFFFFF",
    heading_text: "#FFFFFF",
    hero_background_color: "#464646",
    hero_border: {
        width: '0',
        style: 'solid',
        color: 'transparent',
    },
    hero_controls_background_color: "rgba(50, 50, 50, 0.90)",
    hero_controls_label_text: "#DDDDDD",
    hero_controls_label_font_size: "14px",
    hero_controls_grid_columns: 4,
    hero_controls_accent: "#464646",
    hero_title_text: "#FFFFFF",
    hero_title_font_size: "48px",
    hero_subtitle_text: "#DDDDDD",
    hero_subtitle_font_size: "16px",
    hero_padding: "24px",
    hero_gap: "24px",
    footer_background_color: "#606060",
    footer_title_text: "#FFFFFF",
    footer_title_font_size: "24px",
    tag_background_color: "#323232",
    tag_text: "#DDDDDD",
    tag_font_size: "14px",
    tag_border: {
        width: "1px",
        style: "solid",
        color: "#606060",
        radius: "0px",
    },
    tooltip_background_color: "#253247",
    tooltip_font_size: "14px",
    tooltip_text: "#FFFFFF",
    top_control_panel_border: {
        width: '1px',
        style: 'solid',
        color: '#606060',
    },
    text: "#DDDDDD",
    report_background_content: "#FAFBFC",
    report_background_page: "white",
    report_text: "black",
    report_font_family: "Computer Modern",
    report_font_size: "12px",
    section_padding: "24px",
    section_title_font_size: "24px",
    section_gap: "24px",
};

export default App_Studio_Dark;
